export const formatCurrency = (value: number | null) => {
  if (value === null || value === undefined || value === 0) {
    return "";
  }

  const numberFormatOptions: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  };

  if (value >= 1_000_000) {
    const millions = value / 1_000_000;
    return `${Intl.NumberFormat("en-US", numberFormatOptions).format(millions)}M`;
  } else if (value >= 5_000) {
    const thousands = value / 1_000;
    return `${Intl.NumberFormat("en-US", numberFormatOptions).format(thousands)}K`;
  }
  return new Intl.NumberFormat("en-US", numberFormatOptions).format(value);
};
